<div class="card" *blockUI="'section-block'">
    <div class="row">
        <div class="col-12 mb-50">

        </div>
        <div class="col-md-6 col-12 row">
            <div class="d-flex justify-content-between align-items-center mb-1 ml-1">
                <label class="d-flex align-items-center">
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
            <div>
                <button type="button" class="btn btn-flat-warning ml-1 mb-1" (click)="createCompanyVaultDialog()">
                    Hareket Ekle</button>
            </div>
        </div>

    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;"
        [limit]="selectedSize" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">


        <ngx-datatable-column name="Hesap Adı" prop="title"></ngx-datatable-column>
        <ngx-datatable-column name="İşlem Yapan">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.usernameAndLastName ?? row.userName }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Fiyat">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.balance | number:'1.2-2'}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="İşlem Tipi">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="badge badge-pill" [ngClass]="{
                    'badge-light-danger': row.kindId == 13,
                    'badge-light-success': row.kindId == 15
                }">
                    {{row.typeName}}
                </div>

            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="İşlem Tarihi">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.cratedAt | date:'dd.MM.yyyy HH:mm'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>

            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>